import React from "react";
import { useEffect, useState } from "react";
import {
  useCreateCBBOMutation,
  useUpdateCbboLeadByIdMutation,
  useGetCBBOListQuery,
} from "features/onboarding/organizations/FarmersGroup/CBBO/CBBOApiSlice";
import {
  useCreateFPOMutation,
  useUpdateFPOLeadByIdMutation,
} from "features/onboarding/organizations/FarmersGroup/FPO/FPOApiSlice";
import { Button, Col, Row, Spinner, Card } from "react-bootstrap";
import CustomTextField from "components/CustomTextField";
import { Input, Label, FormGroup } from "reactstrap";
import swal from "sweetalert";

import Select from "react-select";
import axios from "axios";
import { Divider } from "@mui/material";
import { useGetCropListQuery } from "../RiskManagement/RiskManagementApiSlice";
import { Sync } from "@mui/icons-material";
import ProjectAnalyticsSection from "./ProjectAnalyticsSection";
// import { API_URL } from "app/config";
import { store } from "app/store";
// import set from "date-fns/fp/set";
import {
  useGetCommoditiesAllDataQuery,
  useGetCommoditiesCategoriesQuery,
} from "features/Procurement/common/ProcurementApiSlice";
const moduleOptionsFpo = [
  "Farmers",
  "Field Activities",
  "Advisory",
  "Saptashati",
  "Cluster Map",
  "E-Mandi",
  "Live Mandi Prices",
  "Employees",
  "Aggregation",
  "Commodities",
];
const moduleOptionsCbbo = [
  "FPO",
  "Farmers",
  "Field Activities",
  "Advisory",
  "Saptashati",
  "Cluster Map",
  "E-Mandi",
  "Live Mandi Prices",
  "Aggregation",
  "Commodities",
];

export const ProjectModalComponent = ({
  refetch,
  active,
  setAddModel,
  defaultValue,
}) => {
  const [loader, setLoader] = useState(false);
  const [projectName, setProjectName] = useState("");
  const [projectUrl, setProjectUrl] = useState("");
  const [selectedCrops, setSelectedCrops] = useState([]);
  const [selectedModules, setSelectedModules] = useState({});
  const [aliases, setAliases] = useState({});
  const [states, setStates] = useState([]);
  const [districts, setDistricts] = useState([]);
  const [selectedStates, setSelectedStates] = useState([]);
  const [selectedDistricts, setSelectedDistricts] = useState([]);
  const [CBBOData, setCBBOData] = useState({
    project_name: "",
    organization_category: "",
    organization_type: "",
    project_sector: "",
    organization_sector: "",
    email: "",
    phone_number: "",
    reporting_to: "",
  });
  const [selectedCBBO, setSelectedCBBO] = useState({ id: "", name: "" });

  const { data: CbboList } = useGetCBBOListQuery({
    pagination: "",
    searchKey: "",
  });
  const { data: getCommodity } = useGetCommoditiesAllDataQuery();
  console.log("getCommodity", getCommodity);

  const [createCBBO] = useCreateCBBOMutation();
  const [updateCbboLead] = useUpdateCbboLeadByIdMutation();
  const [createFPO] = useCreateFPOMutation();
  const [updateFPOLead] = useUpdateFPOLeadByIdMutation();
  const [assignedZoneOption, setAssignedZoneOption] = useState(null);
  const assignedZone = assignedZoneOption?.value;
  const { data: cropList } = useGetCropListQuery();
  const [CBBOList, setCbboList] = useState([]);
  const [showAnalytics, setShowAnalytics] = useState(false);
  const [showLegends, setShowLegend] = useState(false);
  const [selectedTypes, setSelectedTypes] = useState({});
  const [typeAliases, setTypeAliases] = useState({});
  const [indexSelection, setIndexSelection] = useState({});
  const [indexAliases, setIndexAliases] = useState({});
  const [SaptashatiUrl, setSaptashatiUrl] = useState("");
  const [AdvisoryUrl, setAdvisoryUrl] = useState("");
  const [selectedCommodities, setSelectedCommodities] = useState([]);
  const [ShowCustomUi, setShowCustomUi] = useState(false);
  const handleChange = (event) => {
    setCBBOData({
      ...CBBOData,
      [event.target.name]: event.target.value,
    });
  };
  const handleChangeCBBO = (e) => {
    const selectedId = e.target.value;
    const selectedItem = CBBOList.find((item) => item.id === selectedId);
    setSelectedCBBO({
      id: selectedId,
      name: selectedItem?.organization_name || "",
      project_url: selectedItem?.project?.project_url,
    });
    setCBBOData((prev) => ({
      ...prev,
      reporting_to: e.target.value || "",
    }));
  };

  const optionCrop = [
    {
      label: "Crop",
      options: cropList?.data?.results?.map((crop) => ({
        label: `${crop.crop_name}`,
        value: `${crop.crop_name}`,
      })),
    },
  ];

  const handleModuleChange = (module) => {
    const updated = { ...selectedModules, [module]: !selectedModules[module] };
    setSelectedModules(updated);
    if (!selectedModules[module]) {
      setAliases((prev) => ({ ...prev, [module]: module }));
    } else {
      setAliases((prev) => {
        const updated = { ...prev };
        delete updated[module];
        return updated;
      });
    }
  };

  const handleAliasChange = (module, value) => {
    setAliases((prev) => ({ ...prev, [module]: value }));
  };
  useEffect(() => {
    if (CbboList !== undefined) {
      const filteredData = CbboList?.data?.results?.filter(
        (item) => item.project !== null
      );
      setCbboList(filteredData);
    }
  }, [CbboList]);
  useEffect(() => {
    axios
      .get("https://pixstack.leadsnextech.com/location_master?level=State")
      .then((res) => {
        const formatted =
          res.data?.data?.map((item) => ({
            label: item.state_name,
            value: item.state_code,
          })) || [];
        setStates(formatted);
      });
  }, []);

  useEffect(() => {
    if (defaultValue?.fullData) {
      const { fullData } = defaultValue;
      console.log("fullData", fullData);
      const zone = defaultValue.fullData.zone_level;
      // console.log("full", fullData);
      // setProjectName(fullData.project_name || "");
      // setProjectUrl(fullData.project_url || "");
      // setProjectName(fullData?.sub_project?fullData?.sub_project?.project_name:fullData?.project_name);
      setProjectUrl(
        fullData?.sub_project
          ? fullData?.sub_project?.project_url
          : fullData?.project_url
      );
      setSelectedCrops(
        (fullData.crops || []).map((crop) => ({ label: crop, value: crop }))
      );
      setAssignedZoneOption(zone ? { label: zone, value: zone } : null);
      setSelectedStates(fullData.states || []);
      setSelectedDistricts(fullData.districts || []);
      setSelectedModules(
        Object.keys(fullData.modules || {}).reduce((acc, mod) => {
          acc[mod] = true;
          return acc;
        }, {})
      );
      setAliases({ ...fullData.modules });
      setCBBOData({
        project_name: fullData?.sub_project
          ? fullData?.sub_project?.project_name
          : fullData?.project_name,
        email: defaultValue.email || "",
        phone_number: defaultValue.phone_number || "",
        organization_category: defaultValue?.organization_category,
        organization_type: defaultValue?.organization_type,
        organization_sector: defaultValue?.organization_sector,
        reporting_to: defaultValue?.reporting_to?.id || "",
        crop_mask_url: fullData?.analytics?.crop_mask_url,
        kharif_task_id: fullData?.analytics?.kharif_task_id,
        rabi_task_id: fullData?.analytics?.rabi_task_id,
      });
      setShowAnalytics(fullData?.analytics?.analytics);
       setShowCustomUi(fullData?.showCustomUiDesign);
        setSelectedCommodities(fullData?.selectedCommodities);
      setSelectedCBBO({
        id: defaultValue?.reporting_to?.id,
        name: defaultValue?.reporting_to?.organization_name,
        project_url: fullData?.sub_project
          ? fullData?.project_url
          : fullData?.sub_project?.project_url,
      });
      setShowLegend(fullData?.showLegends);
      setGetImages(fullData?.uploadedFiles);
      setSaptashatiUrl(fullData?.SaptashatiUrl);
      setAdvisoryUrl(fullData?.AdvisoryUrl);
      if (fullData?.analytics?.analytics_activeTab) {
        const selected = {};
        const typeAliasMap = {};
        const indexSelectMap = {};
        const indexAliasMap = {};
        fullData.analytics.analytics_activeTab.forEach((item) => {
          const { type, alias, indices } = item;
          selected[type] = true;
          typeAliasMap[type] = alias;
          indexSelectMap[type] = indices.map((i) => i.name);
          indexAliasMap[type] = {};
          indices.forEach((i) => {
            indexAliasMap[type][i.name] = i.alias;
          });
        });
        setSelectedTypes(selected);
        setTypeAliases(typeAliasMap);
        setIndexSelection(indexSelectMap);
        setIndexAliases(indexAliasMap);
       
      }
    }
  }, [defaultValue]);

  useEffect(() => {
    if (assignedZone === "District" && selectedStates[0]) {
      const stateId = selectedStates[0].value;
      axios
        .get(
          `https://pixstack.leadsnextech.com/location_master?level=District&state_id=${stateId}`
        )
        .then((res) => {
          const formatted =
            res.data?.data?.map((item) => ({
              label: item.district_name,
              value: item.district_code,
            })) || [];
          setDistricts(formatted);
        });
    }
  }, [assignedZone, selectedStates]);
  const [password, setPassword] = useState("");

  const generatePassword = () => {
    const charset =
      "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789@#$";
    let pass = "";
    for (let i = 0; i < 8; i++) {
      pass += charset[Math.floor(Math.random() * charset.length)];
    }
    setPassword(pass);
  };
  const getAnalyticsPayload = () => {
    const payload = [];
    Object.keys(selectedTypes).forEach((type) => {
      if (selectedTypes[type]) {
        const indices = (indexSelection[type] || []).map((index) => ({
          name: index,
          alias: indexAliases[type]?.[index] || index,
        }));
        payload.push({
          type,
          alias: typeAliases[type],
          indices,
        });
      }
    });
    return payload;
  };
  const uploadAll = async (files) => {
    const formData = new FormData();
    files.forEach(({ file }) => formData.append("files", file));
    const {
      auth: { accessToken },
    } = store.getState();
    const {
      data,
    } = await axios.post(
      `https://vaaradhi-dev.agrani.tech/api/v1/onboarding/upload-to-s3`,
      formData,
      { headers: { authorization: `Bearer ${accessToken}` } }
    );

    return data.stored || data;
  };
  const [getImages, setGetImages] = useState([]);
  // console.log("getImages", getImages);

  // console.log("images00", getImages);
  console.log("showAnalytics",showAnalytics)
  // console.log("third", third);
  const handleSubmitProject = async (e) => {
    e.preventDefault();
    setLoader(true);

    const analyticsDetailView = await getAnalyticsPayload();
    const filesToUpload = [...images, ...videos];
    let uploadedFiles = [];
    if (images.length > 0 || videos.length > 0) {
      uploadedFiles = await uploadAll(filesToUpload);
    }
    // console.log("uploadedFiles", uploadedFiles);
    if (showAnalytics && !CBBOData.rabi_task_id && !CBBOData.kharif_task_id) {
      setLoader(false);

      return swal({
        icon: "warning",
        title: "Missing Task ID",
        text: "Please select either Rabi or Kharif task ID.",
      });
    }
    if (
      showAnalytics &&
      (!analyticsDetailView || analyticsDetailView.length === 0)
    ) {
      setLoader(false);

      return swal({
        icon: "warning",
        title: "No Analytics Selected",
        text: "Please configure and select at least one analytics module.",
      });
    }

    if (showAnalytics) {
      for (let item of analyticsDetailView) {
        if (
          (item.type === "MSI" ||
            item.type === "Weather" ||
            item.type === "SAR") &&
          (!item.indices || item.indices.length === 0)
        ) {
          setLoader(false);

          return swal({
            icon: "warning",
            title: `Missing Indices for ${item.type}`,
            text: `Please select at least one index for ${item.type}.`,
          });
        }
      }
    }
    const finalAliases = {};
    // setLoader(true);
    Object.keys(selectedModules).forEach((mod) => {
      if (selectedModules[mod]) {
        finalAliases[mod] = aliases[mod]?.trim() || mod;
      }
    });
    // console.log("all get images", getImages);
    if (active === "CBBO") {
      // console.log("entering");
      const payload = {
        organization_name: CBBOData.project_name,
        organization_category: "Farmer Groups",
        organization_type: "CBBO",
        organization_sector: CBBOData.organization_sector,
        email: CBBOData.email,
        phone_number: CBBOData.phone_number,
        project: {
          project_name: CBBOData.project_name,
          project_url: projectUrl,
          crops: selectedCrops.map((crop) => crop.value),
          modules: finalAliases,
          zone_level: assignedZone,
          states: selectedStates,
          districts: selectedDistricts,
          showLegends: showLegends,
          uploadedFiles:
            getImages?.length > 0
              ? [...uploadedFiles, ...getImages]
              : uploadedFiles,
          analytics: {
            analytics: showAnalytics,
            rabi_task_id: showAnalytics ? CBBOData.rabi_task_id : "",
            kharif_task_id: showAnalytics ? CBBOData.kharif_task_id : "",
            crop_mask_url: showAnalytics ? CBBOData.crop_mask_url : "",
            analytics_activeTab: showAnalytics ? analyticsDetailView : "",
          },
          ...(SaptashatiUrl && { SaptashatiUrl: SaptashatiUrl }),
          ...(AdvisoryUrl && { AdvisoryUrl: AdvisoryUrl }),
          ...(selectedCommodities && {
            selectedCommodities: selectedCommodities,
          }),
          showCustomUiDesign: ShowCustomUi,
        },
      };
      if (defaultValue?.fullData) {
        updateCbboLead({ id: defaultValue?.projectId, payload: payload })
          .unwrap()
          .then((data) => {
            if (data.success) {
              swal("Project Updated Successfully", {
                buttons: false,
                icon: "success",
                title: "Project Updated",
                timer: 1500,
              });
              setLoader(false);
              setAddModel(false);
              setLoader(false);
              refetch();
            } else {
              swal("Oops", {
                buttons: false,
                icon: "warning",
                title: "Something went wrong !!!",
                timer: 1500,
              });
            }
          });
      } else {
        payload.password = password;
        createCBBO(payload)
          .unwrap()
          .then((data) => {
            if (data.success) {
              swal("Applicant Created Successfully", {
                buttons: false,
                icon: "success",
                title: "Applicant Created Detail",
                timer: 1500,
              });
              refetch();
              setLoader(false);
              setAddModel(false);
              setLoader(false);
            }
          })
          .catch((data) => {
            if (data.data.error.code === 400) {
              swal("All Fields are mandatory", {
                buttons: false,
                icon: "warning",
                title: "Please fill full Details",
                timer: 1500,
              });
              setLoader(false);

              return;
            } else if (data.data.error.code === 409) {
              swal("!!", {
                buttons: false,
                icon: "warning",
                title: data.data.error.message,
                timer: 2000,
              });
              setLoader(false);
            }
          });
      }
    } else if (active === "FPO") {
      const isCBBOSelected =
        selectedCBBO.id !== undefined && selectedCBBO.id !== "";
      let payload = {
        organization_name: CBBOData.project_name,
        organization_category: "Farmer Groups",
        organization_type: "FPO",
        organization_sector: CBBOData.organization_sector,
        email: CBBOData.email,
        phone_number: CBBOData.phone_number,
        reporting_organization_id: isCBBOSelected ? selectedCBBO.id : "",
      };

      if (defaultValue?.fullData) {
        let projectData = {
          project_name: isCBBOSelected
            ? selectedCBBO.name
            : CBBOData.project_name,
          project_url: isCBBOSelected ? selectedCBBO?.project_url : projectUrl,
          crops: selectedCrops.map((crop) => crop.value),
          modules: finalAliases,
          zone_level: assignedZone,
          states: selectedStates,
          districts: selectedDistricts,
          showLegends: showLegends,
          uploadedFiles:
            getImages?.length > 0
              ? [...uploadedFiles, ...getImages]
              : uploadedFiles,
          analytics: {
            analytics: showAnalytics,
            rabi_task_id: showAnalytics ? CBBOData.rabi_task_id : "",
            kharif_task_id: showAnalytics ? CBBOData.kharif_task_id : "",
            crop_mask_url: showAnalytics ? CBBOData.crop_mask_url : "",
            analytics_activeTab: showAnalytics ? analyticsDetailView : "",
          },
          ...(SaptashatiUrl && { SaptashatiUrl: SaptashatiUrl }),
          ...(AdvisoryUrl && { AdvisoryUrl: AdvisoryUrl }),
          ...(selectedCommodities && {
            selectedCommodities: selectedCommodities,
          }),
          showCustomUiDesign: ShowCustomUi,
        };
        if (isCBBOSelected) {
          projectData.sub_project = {
            project_name: CBBOData.project_name,
            project_url: projectUrl,
          };
        }
        payload.project = projectData;
        updateFPOLead({ id: defaultValue?.projectId, payload: payload })
          .unwrap()
          .then((data) => {
            if (data.success) {
              swal("Project Updated Successfully", {
                buttons: false,
                icon: "success",
                title: "FPO Updated",
                timer: 1500,
              });
              setLoader(false);
              setAddModel(false);
              refetch();
              setLoader(false);
            } else {
              swal("Oops", {
                buttons: false,
                icon: "warning",
                title: "Something went wrong !!!",
                timer: 1500,
              });
              setLoader(false);
            }
          });
      } else {
        const isCBBOSelected =
          selectedCBBO.id !== undefined && selectedCBBO.id !== "";
        const baseProject = {
          project_name: isCBBOSelected
            ? selectedCBBO.name
            : CBBOData.project_name,
          // project_url: projectUrl,
          project_url: isCBBOSelected ? selectedCBBO?.project_url : projectUrl,
          crops: selectedCrops.map((crop) => crop.value),
          modules: finalAliases,
          zone_level: assignedZone,
          states: selectedStates,
          districts: selectedDistricts,
          showLegends: showLegends,
          uploadedFiles:
            getImages?.length > 0
              ? [...uploadedFiles, ...getImages]
              : uploadedFiles,
          ...(SaptashatiUrl && { SaptashatiUrl: SaptashatiUrl }),
          ...(AdvisoryUrl && { AdvisoryUrl: AdvisoryUrl }),
          ...(selectedCommodities && {
            selectedCommodities: selectedCommodities,
          }),
          showCustomUiDesign: ShowCustomUi,
        };
        if (isCBBOSelected) {
          baseProject.sub_project = {
            project_name: CBBOData.project_name,
            project_url: projectUrl,
          };
        }
        baseProject.analytics = {
          analytics: showAnalytics,
          rabi_task_id: showAnalytics ? CBBOData.rabi_task_id : "",
          kharif_task_id: showAnalytics ? CBBOData.kharif_task_id : "",
          crop_mask_url: showAnalytics ? CBBOData.crop_mask_url : "",
          analytics_activeTab: showAnalytics ? analyticsDetailView : "",
          showLegends: showLegends,
        };
        payload.password = password;
        payload.project = baseProject;

        createFPO(payload)
          .unwrap()
          .then((data) => {
            if (data.success) {
              swal("Project Created Successfully", {
                buttons: false,
                icon: "success",
                title: "Applicant Created Detail",
                timer: 1500,
              });
              refetch();
              setLoader(false);
              setAddModel(false);
            }
          })
          .catch((data) => {
            if (data.data.error.code == 400) {
              swal("All Fields are mandatory", {
                buttons: false,
                icon: "warning",
                title: "Please fill full Details",
                timer: 1500,
              });
              setLoader(false);

              return;
            } else if (data.data.error.code == 409) {
              swal("!!", {
                buttons: false,
                icon: "warning",
                title: data.data.error.message,
                timer: 2000,
              });
              setLoader(false);
            }
          });
      }
    }
  };

  const customStyles = {
    control: (base) => ({
      ...base,
      minHeight: 45,
    }),
  };
  const [images, setImages] = useState([]);
  const [videos, setVideos] = useState([]);

  const handleMediaUpload = (e) => {
    const newFiles = Array.from(e.target.files);

    const newImages = [];
    const newVideos = [];

    newFiles.forEach((file) => {
      const preview = URL.createObjectURL(file);
      if (file.type.startsWith("image/")) {
        newImages.push({ file, preview });
      } else if (file.type.startsWith("video/")) {
        newVideos.push({ file, preview });
      }
    });

    setImages((prev) => [...prev, ...newImages]);
    setVideos((prev) => [...prev, ...newVideos]);

    e.target.value = "";
  };

  useEffect(() => {
    return () => {
      images.forEach((img) => URL.revokeObjectURL(img.preview));
      videos.forEach((vid) => URL.revokeObjectURL(vid.preview));
    };
  }, [images, videos]);

  const commodityOptions = getCommodity?.data?.map((item) => ({
    value: item.code,
    label: item.name,
    name: item.name,
    image_url: item.image_url,
    category: item.category,
    code: item.code,
  }));

  const handleCommodityChange = (selectedOptions) => {
    const formattedData = selectedOptions.map((option) => ({
      name: option.label,
      image_url: option.image_url, // Assuming you stored it in option object
      category: option.category,
      code: option.value,
    }));
    setSelectedCommodities(formattedData);
  };

  console.log("selectedCommodities", selectedCommodities);

  return (
    <div className="">
      <form onSubmit={(e) => handleSubmitProject(e)}>
        <Card className="p-3 rounded-4 border-0 shadow-sm bg-white">
          <Row className="">
            <Col lg="3" className="mb-3">
              <CustomTextField
                type="text"
                name="project_name"
                placeholder="Enter name"
                onChange={handleChange}
                value={CBBOData?.project_name}
                required
              />
            </Col>
            <Col lg="3" className=" mb-2">
              <label className=" mb-2" style={{ color: "black" }}>
                Project Sector <span className="checkingcss">*</span>
              </label>
              <Input
                type="select"
                className="form-control "
                style={{
                  padding: "9px",
                  borderRadius: "4px",
                  border: "1px solid rgba(151, 151, 151, 0.3)",
                }}
                onChange={handleChange}
                value={CBBOData?.organization_sector}
                name="organization_sector"
                required
              >
                <option value="">Select Sector</option>
                <option value="Private"> Private </option>
                <option value="Government"> Government </option>
                <option value="NBFC"> NBFC </option>
                <option value="Societies"> Societies </option>
                <option value="NGO">NGO </option>
                <option value="Parternship"> Parternship </option>
                <option value="Other"> Other </option>
              </Input>
            </Col>

            <Col lg="6">
              <Label>Project Logo URL</Label>
              <Input
                type="text"
                className="rounded-1"
                placeholder="Enter logo URL"
                value={projectUrl}
                onChange={(e) => setProjectUrl(e.target.value)}
              />
            </Col>
            <Col lg="2" className="mb-3">
              <CustomTextField
                type="text"
                name="phone_number"
                placeholder="1234567890"
                minLength="10"
                maxLength="10"
                onChange={handleChange}
                value={CBBOData?.phone_number}
                required
              />
            </Col>
            <Col lg="3" className="mb-3">
              <CustomTextField
                type="email"
                name="email"
                placeholder="someone@example.com"
                onChange={handleChange}
                value={CBBOData?.email}
                required
              />
            </Col>

            <Col lg="3">
              <Label>Select Crops</Label>
              <Select
                isMulti
                value={selectedCrops}
                onChange={(selectedOptions) => {
                  setSelectedCrops(selectedOptions);
                }}
                options={optionCrop}
                classNamePrefix="select2-selection"
                styles={customStyles}
              />
            </Col>

            {!defaultValue?.fullData && (
              <Col md="4" className="mb-3">
                <Label>
                  Password <span className="text-danger">*</span>
                </Label>
                <div className="d-flex">
                  <Input
                    type="text"
                    className="rounded-1"
                    placeholder="Enter or generate password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    required
                  />
                  <Button
                    type="button"
                    color="secondary"
                    onClick={generatePassword}
                    className="ms-2 d-flex align-items-center gap-1"
                  >
                    <Sync style={{ fontSize: "14px" }} /> Generate
                  </Button>
                </div>
              </Col>
            )}

            <Divider className="mb-2" />
            <Row>
              <Col md="12" className="mb-2">
                <h4 className="mb-2 text-xl font-semibold text-primary h5 mt-2">
                  🧩 Modules & Aliases
                </h4>
                <Row>
                  {(active === "CBBO"
                    ? moduleOptionsCbbo
                    : moduleOptionsFpo
                  ).map((module, index) => (
                    <Col md="6" key={module} className="mb-2">
                      <FormGroup className="d-flex align-items-center">
                        <Input
                          type="checkbox"
                          checked={!!selectedModules[module]}
                          onChange={() => handleModuleChange(module)}
                          className="me-2 cursor"
                          style={{ flexShrink: 0 }}
                        />
                        <Label
                          className="mb-0 me-2 mt-1"
                          style={{ minWidth: "120px", flexShrink: 0 }}
                        >
                          {module}
                        </Label>
                        {selectedModules[module] && (
                          <Input
                            type="text"
                            value={aliases[module] ?? module}
                            onChange={(e) =>
                              handleAliasChange(module, e.target.value)
                            }
                            placeholder={`Alias for ${module}`}
                            className="rounded-1"
                            style={{ width: "50%" }}
                          />
                        )}
                        {module === "Saptashati" && selectedModules[module] && (
                          <Input
                            type="url"
                            value={SaptashatiUrl}
                            onChange={(e) => setSaptashatiUrl(e.target.value)}
                            placeholder="Saptashati URL"
                            className="rounded-1 ms-2"
                            style={{ width: "100%" }}
                          />
                        )}
                        {module === "Advisory" && selectedModules[module] && (
                          <Input
                            type="url"
                            value={AdvisoryUrl}
                            onChange={(e) => setAdvisoryUrl(e.target.value)}
                            placeholder="Advisory URL"
                            className="rounded-1 ms-2"
                            style={{ width: "100%" }}
                          />
                        )}
                      </FormGroup>
                      <Col md="7" className="offset-md-3">
                        {module === "Commodities" && selectedModules[module] && (
                          // <Select
                          //   isMulti
                          //   options={commodityOptions}
                          //   onChange={handleCommodityChange}
                          //   placeholder="Choose Commodity"
                          //   menuPlacement="auto"
                          //   styles={customStyles}
                          //   value={selectedCommodities}
                          // />
                          <Select
                            isMulti
                            options={commodityOptions}
                            onChange={handleCommodityChange}
                            placeholder="Choose Commodity"
                            menuPlacement="auto"
                            styles={customStyles}
                            value={commodityOptions?.filter((opt) =>
                              selectedCommodities?.some(
                                (sel) => sel.code === opt.value
                              )
                            )}
                          />
                        )}
                      </Col>
                    </Col>
                  ))}
                </Row>
              </Col>
            </Row>
          </Row>

          <Divider className="mb-2" />
          <h4 className="mb-2 text-xl font-semibold text-primary mt-2">
            📍 Operational Area
          </h4>

          <Row className="mb-2">
            <Col lg="3">
              <Label>
                Assigned Zone <span className="checkingcss">*</span>
              </Label>
              <Select
                options={[
                  { label: "State", value: "State" },
                  { label: "District", value: "District" },
                ]}
                onChange={(val) => {
                  setAssignedZoneOption(val);
                  setSelectedStates([]);
                  setSelectedDistricts([]);
                }}
                styles={customStyles}
                value={assignedZoneOption}
                placeholder="Select zone level"
                required
              />
            </Col>

            {assignedZone === "State" && (
              <Col lg="5">
                <Label>Select State(s)</Label>
                <Select
                  isMulti
                  options={states}
                  value={selectedStates}
                  onChange={setSelectedStates}
                  placeholder="Choose states"
                  menuPlacement="auto"
                  styles={customStyles}
                />
              </Col>
            )}
            {assignedZone === "District" && (
              <>
                <Col lg="3">
                  <Label>Select State</Label>
                  <Select
                    options={states}
                    value={selectedStates[0] || null}
                    onChange={(val) => setSelectedStates([val])}
                    placeholder="Choose state"
                    menuPlacement="auto"
                    styles={customStyles}
                  />
                </Col>
                <Col lg="5">
                  <Label>Select District(s)</Label>
                  <Select
                    isMulti
                    options={districts}
                    value={selectedDistricts}
                    onChange={setSelectedDistricts}
                    placeholder="Choose districts"
                    menuPlacement="auto"
                    styles={customStyles}
                  />
                </Col>
              </>
            )}
          </Row>

          {active === "FPO" ? (
            <Row>
              <Divider />
              <Col lg="3" className=" mb-2 mt-2">
                <h4 className="mb-2 text-xl font-semibold text-primary h5 mt-2">
                  🗃️ Parent Project
                </h4>
                <Input
                  type="select"
                  className="form-control "
                  style={{
                    padding: "9px",
                    borderRadius: "4px",
                    border: "1px solid rgba(151, 151, 151, 0.3)",
                  }}
                  onChange={handleChangeCBBO}
                  name="reporting_organization_id"
                  value={CBBOData?.reporting_to}
                >
                  <option value="">Select CBBO </option>
                  {CBBOList?.map((item) => {
                    return (
                      <option value={item.id}>
                        {" "}
                        {item.organization_name}{" "}
                      </option>
                    );
                  })}
                </Input>
              </Col>
            </Row>
          ) : (
            ""
          )}

          <Divider className="my-2" />
          <h4 className="mb-2 text-xl font-semibold text-primary">
            <i className="mdi mdi-chart-line "></i> Analytics
          </h4>
          <Row className="align-items-center mb-1">
            <Col lg="12">
              <Input
                type="checkbox"
                id="analytics-checkbox"
                checked={showAnalytics}
                onChange={(e) => setShowAnalytics(e.target.checked)}
                className="fw-semibold"
              />
              <Label
                className="mx-3"
                style={{ minWidth: "120px", flexShrink: 0 }}
              >
                <i>Do you want to see Analytics ?</i>
              </Label>
            </Col>
          </Row>

          {showAnalytics && (
            <Row className="mb-3 mt-1">
              <Col lg="3">
                <CustomTextField
                  type="text"
                  name="rabi_task_id"
                  placeholder="Enter Rabi Task ID"
                  onChange={handleChange}
                  value={CBBOData?.rabi_task_id || ""}
                />
              </Col>

              <Col lg="3">
                <CustomTextField
                  type="text"
                  name="kharif_task_id"
                  placeholder="Enter Kharif Task ID"
                  onChange={handleChange}
                  value={CBBOData?.kharif_task_id || ""}
                />
              </Col>

              <Col lg="6">
                <CustomTextField
                  type="text"
                  name="crop_mask_url"
                  placeholder="Enter Crop Mask URL"
                  onChange={handleChange}
                  value={CBBOData?.crop_mask_url || ""}
                />
              </Col>
              <Col lg="12">
                <ProjectAnalyticsSection
                  selectedTypes={selectedTypes}
                  setSelectedTypes={setSelectedTypes}
                  typeAliases={typeAliases}
                  setTypeAliases={setTypeAliases}
                  indexSelection={indexSelection}
                  setIndexSelection={setIndexSelection}
                  indexAliases={indexAliases}
                  setIndexAliases={setIndexAliases}
                />
              </Col>
            </Row>
          )}
          <Divider className="my-2" />
          <h4 className="mb-2 text-xl font-semibold text-primary">
            <i className="mdi mdi-map "></i> Legend
          </h4>
          <Row className="align-items-center mb-1">
            <Col lg="12">
              <Input
                type="checkbox"
                id="analytics-checkbox"
                checked={showLegends}
                onChange={(e) => setShowLegend(e.target.checked)}
                className="fw-semibold"
              />
              <Label
                className="mx-3"
                style={{ minWidth: "120px", flexShrink: 0 }}
              >
                <i>Do you want to see Legend ?</i>
              </Label>
            </Col>
          </Row>
          <Divider className="my-2" />
          <h4 className="mb-2 text-xl font-semibold text-primary">
            <i className="mdi mdi-map "></i> Custom UI
          </h4>
          <Row className="align-items-center mb-1">
            <Col lg="12">
              <Input
                type="checkbox"
                id="analytics-checkbox"
                checked={ShowCustomUi}
                onChange={(e) => setShowCustomUi(e.target.checked)}
                className="fw-semibold"
              />
              <Label
                className="mx-3"
                style={{ minWidth: "120px", flexShrink: 0 }}
              >
                <i>Do you want to see Custom Ui ?</i>
              </Label>
            </Col>
          </Row>
          {selectedModules["Field Activities"] && (
            <>
              <>
                <Divider className="my-2" />
                <h4 className="mb-2 text-xl font-semibold text-primary">
                  <i className="mdi mdi-upload"></i> Upload Media
                </h4>

                <Row className="align-items-center mb-3">
                  <Col lg="12">
                    <Label
                      htmlFor="media-upload"
                      className="form-label fw-semibold"
                    >
                      Upload Images / Videos
                    </Label>
                    <Input
                      type="file"
                      id="media-upload"
                      multiple
                      accept="image/*,video/*"
                      onChange={handleMediaUpload}
                    />
                  </Col>
                </Row>
              </>
            </>
          )}
          {/* <Row className="mt-3">
             {(getImages?.length > 0 ? [...images, ...getImages] : images).map(
              (img, index) => (
                <Col key={index} xs="6" md="2" className="mb-3">
                  
                  <div
                    className="border p-2 rounded text-center"
                    style={{ position: "relative" }}
                  >
                    <img
                      src={img.url ? img.url : img.preview}
                      className="img-fluid rounded"
                      style={{
                        maxHeight: 80,
                        objectFit: "cover",
                        width: "100%",
                      }}
                      alt={img.file?.name || img.name || `image-${index}`}
                    />
                    <div className="small mt-1 text-truncate">
                      {img.file?.name || img.name}
                    </div>
                    <i
                      className="mdi mdi-trash-can cursor-pointer"
                      style={{ color: "orange" }}
                      onClick={() => {
                        if (img.url) {
                          const filteredData = getImages?.filter(
                            (image) => img.url !== image.url
                          );
                          setGetImages(filteredData);
                        } else {
                          const filteredImages = images?.filter(
                            (image) => img.url !== image.url
                          );
                          setImages(filteredImages);
                        }
                      }}
                    />
                  </div>
                </Col>
              )
            )} 
 
          </Row> */}
          {/* {console.log("images", images)} */}
          <Row className="mt-3">
            {(getImages?.length > 0 ? [...images, ...getImages] : images).map(
              (item, index) => (
                <Col key={index} xs="6" md="2" className="mb-3">
                  {item.type?.includes("image") ? (
                    <div
                      className="border p-2 rounded text-center"
                      style={{ position: "relative" }}
                    >
                      <img
                        src={item.url || item.preview}
                        className="img-fluid rounded"
                        style={{
                          maxHeight: 80,
                          objectFit: "cover",
                          width: "100%",
                        }}
                        alt={item.file?.name || item.name || `image-${index}`}
                      />
                      <div className="small mt-1 text-truncate">
                        {item.file?.name || item.name}
                      </div>
                      <i
                        className="mdi mdi-trash-can cursor-pointer"
                        style={{ color: "orange" }}
                        onClick={() => {
                          if (item.url) {
                            const filteredData = getImages?.filter(
                              (img) => item.url !== img.url
                            );
                            setGetImages(filteredData);
                          } else {
                            const filteredImages = images?.filter(
                              (img) => item.preview !== img.preview
                            );
                            setImages(filteredImages);
                          }
                        }}
                      />
                    </div>
                  ) : item.type?.includes("video") ? (
                    <div className="border p-2 rounded text-center">
                      <video
                        src={item.url || item.preview}
                        width="100%"
                        height="120"
                        controls
                        className="rounded"
                      />
                      <div className="small mt-1 text-truncate">
                        {item.name || item.file?.name}
                      </div>
                      <i
                        className="mdi mdi-trash-can cursor-pointer"
                        style={{ color: "orange" }}
                        onClick={() => {
                          if (item.url) {
                            const filteredData = getImages?.filter(
                              (img) => item.url !== img.url
                            );
                            setGetImages(filteredData);
                          } else {
                            const filteredVideos = images?.filter(
                              (img) => item.preview !== img.preview
                            );
                            setImages(filteredVideos);
                          }
                        }}
                      />
                    </div>
                  ) : (
                    <div
                      className="border p-2 rounded text-center"
                      style={{ position: "relative" }}
                    >
                      <img
                        src={item.url || item.preview}
                        className="img-fluid rounded"
                        style={{
                          maxHeight: 80,
                          objectFit: "cover",
                          width: "100%",
                        }}
                        alt={item.file?.name || item.name || `image-${index}`}
                      />
                      <div className="small mt-1 text-truncate">
                        {item.file?.name || item.name}
                      </div>
                      <i
                        className="mdi mdi-trash-can cursor-pointer"
                        style={{ color: "orange" }}
                        onClick={() => {
                          if (item.url) {
                            const filteredData = getImages?.filter(
                              (img) => item.url !== img.url
                            );
                            setGetImages(filteredData);
                          } else {
                            const filteredImages = images?.filter(
                              (img) => item.preview !== img.preview
                            );
                            setImages(filteredImages);
                          }
                        }}
                      />
                    </div>
                  )}
                </Col>
              )
            )}
            {videos.length > 0 && (
              <Row className="mt-3">
                {videos.map((item, index) => (
                  <Col key={index} xs="6" md="2" className="mb-3">
                    <div className="border p-2 rounded text-center">
                      <video
                        src={item.url || item.preview}
                        width="100%"
                        height="120"
                        controls
                        className="rounded"
                      />
                      <div className="small mt-1 text-truncate">
                        {item.name || item.file?.name}
                      </div>
                      <i
                        className="mdi mdi-trash-can cursor-pointer"
                        style={{ color: "orange" }}
                        onClick={() => {
                          if (item.url) {
                            const filteredData = getImages?.filter(
                              (img) => item.url !== img.url
                            );
                            setGetImages(filteredData);
                          } else {
                            const filteredVideos = videos?.filter(
                              (img) => item.preview !== img.preview
                            );
                            setVideos(filteredVideos);
                          }
                        }}
                      />
                    </div>
                  </Col>
                ))}
              </Row>
            )}
          </Row>

          <div className="d-flex justify-content-end">
            <button
              type="submit"
              size="sm"
              className=" saathi-submit-btn px-4"
              style={{ padding: "8px" }}
            >
              <span className="mdi mdi-content-save "></span> Submit &nbsp;
              {loader ? <Spinner size="sm" /> : ""}
            </button>
          </div>
        </Card>
      </form>
    </div>
  );
};
